import React, { FC, useEffect, useState } from "react";
import "./mostLikedContent.scss";
import LikeIcon from "../../../assets/icons/like.svg";
import { Col, Row, Spin } from "antd";
import faker from "faker";
import AttemptsIcon from "../../../assets/icons/attempt.svg";
import PlayIcon from "../../../assets/icons/play.svg";
import PdfIcon from "../../../assets/icons/document.svg";
import ThumbUpIcon from "../../../assets/icons/thumb-up.svg";
import ThumbDownIcon from "../../../assets/icons/thumb-down.svg";
import DashboardFilter from "../DashboardFilter";
import { MostLikedContentModel } from "../../../models/DashboardModel/MostLikedContentModel/mostLikedContent.model";
import ContentPlaceholder from "../../../assets/placeholder/content-placeholder.svg";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { serialize } from "serializr";
import { defaultFilter } from "../../../shared/utils/filter";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";

interface MostLikedContentProps { }

const MostLikedContent: FC<MostLikedContentProps> = (props: any) => {
  const { user } = props;
  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState<MostLikedContentModel[]>([]);
  const fetchMostLikedContents = (params?: any) => {
    setLoading(true)
    const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
    DashboardService.fetchMostLikedContent(
      payload,
      (contents) => {
        setContents(contents);
        setLoading(false);
      },
      () => {
        setLoading(false)
      },
      () => { }
    );
  };

  useEffect(() => {
    if (user?.roleName === 'admin')
      fetchMostLikedContents();
  }, []);
  return (
    <div className="most-liked-content">
      <div className="most-liked-content__header-wrapper">
        <div className="most-liked-content__header">
          <img src={LikeIcon} />
          Most liked content
        </div>
        <DashboardFilter
          applyHandler={(values) => fetchMostLikedContents({ ...defaultFilter, ...values })}
          clearHandler={() => fetchMostLikedContents()} />
      </div>
      <div className="most-liked-content__wrapper">
        {loading ? (
          <Spin tip="Loading..." className="spin__loader" />
        ) : !contents?.length ? (
          <p className="no__data">No data!</p>
        ) : (
          contents?.map((value, index) => {
            return (
              <Row key={"most-liked_#" + index} className="most-liked-content__card">
                <Col span={6}>
                  <img
                    className="most-liked-content__thumbnail"
                    src={value?.contentThumbUrl ?? ContentPlaceholder}
                  />
                </Col>
                <Col span={18}>
                  <div className="most-liked-content__card-right">
                    <p className="most-liked-content__card-title">
                      {value?.contentName}
                    </p>
                    <Row>
                      <Col span={6}>
                        <div className="most-liked-content__card-count attempt">
                          <img src={AttemptsIcon} /> {value?.attempts} attempts
                        </div>
                      </Col>
                      {/* {(value?.contentType == "video" ||
                        value?.contentType == "pdf") && (
                          <Col span={6}>
                            <div className="most-liked-content__card-count pdf">
                              <img src={PdfIcon} /> {value?.contentLength}{" "}
                              {value?.contentType == "video" ? "mins" : "pages"}
                            </div>
                          </Col>
                        )} */}
                      <Col span={6}>
                        <div className="most-liked-content__card-count pdf">
                          <img src={PdfIcon} /> {value?.contentLength}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-liked-content__card-count like">
                          <img src={ThumbUpIcon} /> {value?.likes}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-liked-content__card-count dislike">
                          <img src={ThumbDownIcon} /> {value?.dislikes}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MostLikedContent;
